import { createAction, props } from '@ngrx/store';
import { PaginationRequest } from 'src/app/models/common/paginationRequest';
import { CardsDTO } from 'src/app/models/Cards/cardDTO';

// Card Plafond
export const getCardPlafond = createAction('[Cards] Get Card Available Plafond Action', props<{ code: string }>());
export const loadCardPlafond = createAction('[Cards] Load Card Available Plafond Action', props<{ response: any[] }>());
// Card Systems
export const getCardSystems = createAction('[Cards] Get All Card Systems Action', props<{ pageReq: PaginationRequest }>());
export const loadCardSystems = createAction('[Cards] Load All Card Systems Action', props<{ response: any[] }>());
// Card Layouts
export const getCardLayout = createAction('[Cards] Get All Card Layouts Action', props<{ pageReq: PaginationRequest }>());
export const loadCardLayout = createAction('[Cards] Load All Card Layouts Action', props<{ response: any[] }>());
// Employees
export const getCardEmployeePartyList = createAction('[Cards] Get All Employees Party List Action',
    props<{ customerCode: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadCardEmployeePartyList = createAction('[Cards] Load All Employees Party List Action Action',
    props<{ response: any[] }>());
export const getCardEmployeeParty = createAction('[Cards] Get a Employee party by code Action', props<{ partyCode: string }>());
// Contracts
export const getCardContractList = createAction('[Cards] Get All Contracts Party List Action',
    props<{ customerCode: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadCardContractList = createAction('[Cards] Load All Customer Contracts List Action Action',
    props<{ response: any[] }>());
export const getCardContract = createAction('[Cards] Get a Contract by code Action', props<{ partyCode: string }>());
// Vehicles
export const getCardVehiclesList = createAction('[Cards] Get All Vehicles Party List Action',
    props<{ customerCode: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadCardVehiclesList = createAction('[Cards] Load All Vehicles Party List Action Action',
    props<{ response: any[] }>());
// Cards
export const createCard = createAction('[Cards] Create Card Action', props<{ card: CardsDTO }>());
export const updateCard = createAction('[Cards] Update Card Action', props<{ card: CardsDTO }>());
export const getCard = createAction('[Cards] Get a Card by code Action', props<{ code: string }>());
export const loadCard = createAction('[Cards] Load Card Action Action',
    props<{ response: any[] }>());
export const setCard = createAction('[Cards] Set Card Action', props<{ card: CardsDTO }>());

export const getCustomerCardList = createAction('[Cards] Get All Cards by Customer List Action',
    props<{ container: any, options: any }>());
export const loadCustomerCardList = createAction('[Cards] Load All Cards by Customer List Action',
    props<{ response: any[] }>());
export const getCardFilteredList = createAction('[Cards] Get All Filtered Cards List Action',
    props<{ options: any }>());
export const loadCardFilteredList = createAction('[Cards] Load All Filtered Cards List Action',
    props<{ response: any[] }>());
export const loadCards = createAction('[Cards] Load All Cards Action', props<{ response: any[] }>());
export const resetCard = createAction('[Cards] Reset Card Action');
export const updateCardPrompt = createAction('[Cards] Update Card Prompt Action ', props<{ cardCode: string, promptCode: any[] }>());
export const deleteCardPrompt = createAction('[Cards] Delete Card Prompt Action ', props<{ cardCode: string, promptCode: any[] }>());
export const loadLimitIntervals = createAction('[Cards] Load All Cards LimitIntervals Action', props<{ response: any[] }>());
export const getLimitIntervals = createAction('[Cards] Get All Cards LimitIntervals Action',
    props<{ pageReq: PaginationRequest }>());
export const loadLimitMeasurements = createAction('[Cards] Load All Cards LimitMeasurements Action', props<{ response: any[] }>());
export const getLimitMeasurements = createAction('[Cards] Get All Cards LimitMeasurements Action',
    props<{ pageReq: PaginationRequest }>());
export const getCardTransactionList = createAction('[Cards] Get All Card Transactions List Action',
    props<{ options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadCardTransactionList = createAction('[Cards] Load All Card Transactions List Action',
    props<{ response: any[] }>());
export const saveCardLimits = createAction('[Cards] Save Card Limits Action',
    props<{ cardCode: string, cardLimitCodes: any[] }>());
export const deleteCardLimits = createAction('[Cards] Delete Card Limits Action',
    props<{ cardCode: string, cardLimitCodes: any[] }>());
export const resetCardLimit = createAction('[Cards] Reset Card Limits Action',
    props<{ cardCode: string, limitCode: string }>());
export const resetCardPin = createAction('[Cards] Reset Card Pin Action',
    props<{ cardCode: string }>());
    export const getCardExcelList = createAction('[Cards] Get All Cards Excel List Action',
    props<{ options: any }>());
export const loadCardExcelList = createAction('[Cards] Load All Cards Excel List Action',
    props<{ response: any[] }>());
// Cards Table Configuration Settings
export const getCardTableConfig = createAction(
  "[Cards] Get Card Table Configuration Action",
  props<{ options: any }>()
);
export const loadCardTableConfig = createAction(
  "[Cards] Load Card Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveCardTableConfig = createAction(
  "[Cards] Save Card Table Configuration Action",
  props<{ config: any }>()
);

// Loading
export const resetCardsState = createAction('[Cards] Reset Cards State Action');
export const resetCreation = createAction("[Cards] Reset Creation Action");

export const getLoadingState = createAction('[Cards] Get Card Loading State Action');
export const setLoadingStartState = createAction('[Cards] Set Card Loading Start State Action');
export const setLoadingEndState = createAction('[Cards] Set Card Loading End State Action');
